import { render, staticRenderFns } from "./AcceptableUsePolicy.vue?vue&type=template&id=921b17a2&scoped=true"
import script from "./AcceptableUsePolicy.vue?vue&type=script&lang=js"
export * from "./AcceptableUsePolicy.vue?vue&type=script&lang=js"
import style0 from "./AcceptableUsePolicy.vue?vue&type=style&index=0&id=921b17a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "921b17a2",
  null
  
)

export default component.exports